var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { Icon } from '../Icon';
import * as S from './styles';

var TextFieldClear = function TextFieldClear(_a) {
  var handleClearSearchField = _a.handleClearSearchField,
      visible = _a.visible,
      props = __rest(_a, ["handleClearSearchField", "visible"]);

  return React.createElement(S.TextFieldClearButton, Object.assign({}, props, {
    onClick: handleClearSearchField,
    visible: visible
  }), React.createElement(Icon, {
    name: 'Clear',
    fill: '#fff',
    height: 24,
    width: 24
  }));
};

export { TextFieldClear };